import useInstagramFeed from '../../hooks/useInstagramFeed'
import LazyImage from '../LazyImage/LazyImage'
import './SocialSection.css'

const INSTAGRAM_PROFILE_URL = 'https://www.instagram.com/_misteroficial/'
const INSTAGRAM_LATEST_ENDPOINT = '/api/instagram?limit=6'

const fallbackPosts = [
  {
    id: 'mota-local',
    thumbnail: '/images/burgers/mota.png',
    display_url: '/images/burgers/mota.png',
    caption: 'Burger de Mister',
    permalink: INSTAGRAM_PROFILE_URL,
  },
  {
    id: 'wrap-local',
    thumbnail: '/images/wraps/pollo-caliente.png',
    display_url: '/images/wraps/pollo-caliente.png',
    caption: 'Wrap de Mister',
    permalink: INSTAGRAM_PROFILE_URL,
  },
  {
    id: 'lomo-mister-local',
    thumbnail: '/images/lomos/lomo-mister.png',
    display_url: '/images/lomos/lomo-mister.png',
    caption: 'Lomo de Mister',
    permalink: INSTAGRAM_PROFILE_URL,
  },
  {
    id: 'ensalada-local',
    thumbnail: '/images/ensaladas/ensalada-mister.png',
    display_url: '/images/ensaladas/ensalada-mister.png',
    caption: 'Ensalada de Mister',
    permalink: INSTAGRAM_PROFILE_URL,
  },
]

const SocialSection = () => {
  const postUrls = [
    'https://www.instagram.com/p/DNTK68buXYY/',
    'https://www.instagram.com/p/DNDviudOqoU/',
    'https://www.instagram.com/p/DML9BH-SgGC/?img_index=1',
    'https://www.instagram.com/p/DLqUZ9QSS-l/',
    'https://www.instagram.com/p/DKw33nGshBY/',
    'https://www.instagram.com/p/DKdJPg1sZjE/'
  ]

  const { posts, loading, error } = useInstagramFeed('_misteroficial', 6, {
    fallbackPosts,
    latestEndpoint: INSTAGRAM_LATEST_ENDPOINT,
    postUrls
  })
  const postsByPosition = posts.reduce((mappedPosts, post, index) => {
    const position = typeof post.position === 'number' ? post.position : index
    mappedPosts[position] = post
    return mappedPosts
  }, [])
  const visiblePosts = Array.from({ length: 6 }, (_, index) => {
    const loadedPost = postsByPosition[index]
    return {
      post: loadedPost || fallbackPosts[index % fallbackPosts.length],
      fallbackPost: fallbackPosts[index % fallbackPosts.length],
      isLoading: loading && !loadedPost,
      originalPosition: index
    }
  })
  const orderedVisiblePosts = [
    ...visiblePosts.filter(({ isLoading }) => !isLoading),
    ...visiblePosts.filter(({ isLoading }) => isLoading)
  ]

  const handleInstagramClick = (url = INSTAGRAM_PROFILE_URL) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handlePostClick = (post, isLoading) => {
    if (isLoading) return
    handleInstagramClick(post.permalink)
  }

  return (
    <section className="social-section" id="social">
      <div className="container">
        <div className="social-layout">
          <aside className="social-copy">
            <span>Instagram</span>
            <h3>Seguinos en Instagram.</h3>
            <p>
              Promos, novedades y antojos de todos los días. Si sale algo nuevo,
              lo vas a ver primero en @_misteroficial.
            </p>
            {loading && <p className="instagram-status">Actualizando fotos...</p>}
            {error && <p className="instagram-status">Mostrando lo último de Mister.</p>}
            <button
              className="social-follow-button"
              onClick={() => handleInstagramClick()}
            >
              Seguir a Mister
            </button>
          </aside>

          <div className="social-grid" aria-label="Fotos de Mister en Instagram">
            {orderedVisiblePosts.map(({ post, fallbackPost, isLoading, originalPosition }) => {
              return (
                <button
                  key={`${isLoading ? 'loading' : 'post'}-${originalPosition}-${post.id || 'fallback'}`}
                  type="button"
                  className={`social-image-container ${isLoading ? 'is-loading' : ''}`}
                  onClick={() => handlePostClick(post, isLoading)}
                  disabled={isLoading}
                  aria-label={isLoading ? 'Cargando foto de Mister desde Instagram' : 'Abrir post de Mister en Instagram'}
                >
                  <LazyImage
                    src={post.thumbnail}
                    fallbackSrc={fallbackPost.display_url}
                    alt={post.caption ? `${post.caption.substring(0, 50)}...` : 'Instagram post'}
                    className="social-image"
                    placeholder={fallbackPost.thumbnail}
                    showLoadingIndicator={false}
                    referrerPolicy="no-referrer"
                  />
                  {isLoading && (
                    <span className="social-loading-overlay" aria-hidden="true">
                      <span>Instagram</span>
                      <strong>
                        {originalPosition === 1 ? 'Cargando post' : 'Actualizando fotos'}
                      </strong>
                    </span>
                  )}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialSection
